import React, { Component } from 'react'
import PropTypes from 'prop-types'
import jwtDecode from 'jwt-decode'
import qs from 'query-string'
import { withRouter } from 'react-router'
import { compose } from 'redux'
import { connect } from 'react-redux'

import { signIn } from '../../store/AppState/actions'
import { isOutsideIframe, setToken } from '../../utils/auth'

export class OAuthCallback extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    signIn: PropTypes.func.isRequired,
  }

  componentDidMount = () => {
    const parsedData = qs.parse(window.location.hash)

    if (parsedData) {
      const { access_token: token } = parsedData

      if (token) {
        this.login(token)

        if (isOutsideIframe()) {
          setTimeout(() => {
            this.props.history.push('/')
          }, 200)
        }
      }
    }
  }

  login = token => {
    const { signIn } = this.props
    const { exp, sub, email, name } = jwtDecode(token)

    const user = {
      email,
      id: sub,
      fullName: name,
    }

    signIn(user)
    setToken(token, exp)
  }

  render() {
    return <div>Authenticating</div>
  }
}

const mapDispatchToProps = {
  signIn,
}

export default compose(
  connect(
    null,
    mapDispatchToProps,
  ),
  withRouter,
)(OAuthCallback)
